import { ApplicationConfig, provideZoneChangeDetection,inject, importProvidersFrom  } from '@angular/core';
import { provideRouter } from '@angular/router';
import { bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { routes } from './app.routes';
import { provideHttpClient,withInterceptors  } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { LoaderService } from './service/loader/loader.service';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { UnknownError } from 'http-errors';
import { environment } from '../environments/environment.development';
import { provideFirebaseApp } from '@angular/fire/app';
import { initializeApp } from '@firebase/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';

export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(
   
    withInterceptors([
      (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
        const loaderService = inject(LoaderService);
        loaderService.show();
        return next(req).pipe(
          finalize(() => loaderService.hide())
        );
      }
    ]),
   ),


   provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
   provideAuth(() => getAuth()),
   provideDatabase(() => getDatabase()),
   provideStorage(() => getStorage()),
 provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideAnimationsAsync(),
  
  
  ]
};
